import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Toaster } from "sonner";

const KEY = "sx-theme";
const read = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

export function useTheme(scope) {
  const [pref, setPref] = useState(read);
  useEffect(() => {
    const f = () => setPref(read());
    window.addEventListener("sx-theme", f);
    return () => window.removeEventListener("sx-theme", f);
  }, []);
  const theme = scope === "none" ? "light" : pref || "light";
  useEffect(() => {
    const h = document.documentElement.classList;
    h.toggle("sx-site-light", scope === "site" && theme === "light");
    h.toggle("sx-app-dark", scope === "app" && theme === "dark");
    h.toggle("dark", scope === "app" && theme === "dark");
    document.documentElement.style.colorScheme = theme;
  }, [scope, theme]);
  const toggle = () => {
    try { localStorage.setItem(KEY, theme === "dark" ? "light" : "dark"); } catch { /* storage blocked */ }
    window.dispatchEvent(new Event("sx-theme"));
  };
  return [theme, toggle];
}

export function ThemedToaster(props) {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("sx-app-dark"));
  useEffect(() => {
    const h = document.documentElement;
    const o = new MutationObserver(() => setDark(h.classList.contains("sx-app-dark") || (!h.classList.contains("sx-site-light") && h.style.colorScheme === "dark")));
    o.observe(h, { attributes: true, attributeFilter: ["class", "style"] });
    return () => o.disconnect();
  }, []);
  return <Toaster theme={dark ? "dark" : "light"} {...props} />;
}

export function ThemeToggle({ theme, toggle, className = "", testid = "theme-toggle" }) {
  const dark = theme === "dark";
  return (
    <button onClick={toggle} aria-label={dark ? "Switch to light theme" : "Switch to dark theme"} title={dark ? "Light theme" : "Dark theme"} data-testid={testid}
      className={`grid h-9 w-9 shrink-0 place-items-center rounded-full border transition-colors ${className}`}>
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
